import { render, staticRenderFns } from "./LoadingOrderQuery.vue?vue&type=template&id=106b2874"
import script from "./LoadingOrderQuery.vue?vue&type=script&lang=js"
export * from "./LoadingOrderQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports